/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Imported_SuccessInputs */

const en_translation_imported_success = /** @type {(inputs: Translation_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation imported successfully`)
};

const fr_translation_imported_success = /** @type {(inputs: Translation_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduction importée avec succès`)
};

const de_translation_imported_success = /** @type {(inputs: Translation_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzung erfolgreich importiert`)
};

const it_translation_imported_success = /** @type {(inputs: Translation_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduzione importata con successo`)
};

const ru_translation_imported_success = /** @type {(inputs: Translation_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перевод успешно импортирован.`)
};

const es_translation_imported_success = /** @type {(inputs: Translation_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traducción importada exitosamente`)
};

const zh_cn2_translation_imported_success = /** @type {(inputs: Translation_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译已成功导入`)
};

const ja_translation_imported_success = /** @type {(inputs: Translation_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳が正常にインポートされました`)
};

const hi_translation_imported_success = /** @type {(inputs: Translation_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद सफलतापूर्वक आयात हो गया`)
};

const pt_pt2_translation_imported_success = /** @type {(inputs: Translation_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradução importada com sucesso`)
};

/**
* | output |
* | --- |
* | "Translation imported successfully" |
*
* @param {Translation_Imported_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_imported_success = /** @type {((inputs?: Translation_Imported_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Imported_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_imported_success(inputs)
	if (locale === "de") return de_translation_imported_success(inputs)
	if (locale === "it") return it_translation_imported_success(inputs)
	if (locale === "ru") return ru_translation_imported_success(inputs)
	if (locale === "es") return es_translation_imported_success(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_imported_success(inputs)
	if (locale === "ja") return ja_translation_imported_success(inputs)
	if (locale === "hi") return hi_translation_imported_success(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_imported_success(inputs)
	return en_translation_imported_success(inputs)
});